import {Navigate, Outlet, Route, Routes} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'
import {PrintersListWrapper} from './printers-list/PrintersList'
import {PrinterStoryPage} from './printer-story/PrinterStoryPage'

const printersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Printer Management',
    path: '/apps/printer-management/printers',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const PrintersPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='printers'
          element={
            <>
              <PageTitle breadcrumbs={printersBreadcrumbs}>Printers list</PageTitle>
              <PrintersListWrapper />
            </>
          }
        />
        <Route
          path='printers/:deviceId'
          element={
            <>
              <PageTitle breadcrumbs={printersBreadcrumbs}>Printer story</PageTitle>
              <PrinterStoryPage />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/printer-management/printers' />} />
    </Routes>
  )
}

export default PrintersPage
